export default __webpack_public_path__ + "static/media/outlook.6510ef57.svg";